import { render, staticRenderFns } from "./CookiePopup.vue?vue&type=template&id=08d2fea8&scoped=true&"
import script from "./CookiePopup.vue?vue&type=script&lang=js&"
export * from "./CookiePopup.vue?vue&type=script&lang=js&"
import style0 from "./CookiePopup.vue?vue&type=style&index=0&id=08d2fea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2fea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d2fea8')) {
      api.createRecord('08d2fea8', component.options)
    } else {
      api.reload('08d2fea8', component.options)
    }
    module.hot.accept("./CookiePopup.vue?vue&type=template&id=08d2fea8&scoped=true&", function () {
      api.rerender('08d2fea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CookiePopup.vue"
export default component.exports